import episodeDurationToSeconds from './episodeDurationToSeconds';

class Duration {
  private value: number;

  constructor(duration: string | number) {
    this.value =
      typeof duration === 'string'
        ? episodeDurationToSeconds(duration)
        : duration;
  }

  valueOf(): number {
    return this.value;
  }

  getMinutes(): number {
    return Math.ceil(this.value / 60);
  }

  toISOString(): string {
    return `PT${this.getMinutes()}M`;
  }
}

export default Duration;
